export interface IChannelProviderVariables {
  itau_name?: string;
  itau_u_nomeprojeto?: string;
  itau_u_lk?: string;
  templateCreateSession?: string;
  templateAusente?: string;
  retrieveRecordTable?: string;
  retrieveRecordCol?: string;
  fieldnegocio?: string;
  triggerPlugin?: string;
}

export const ICivicsProvidersConfig: Record<string, IChannelProviderVariables> =
  {
    HUBGERENTES: {
      itau_name: 'Projeto Itaú Resolve',
      itau_u_nomeprojeto: 'Projeto Itaú Resolve',
      itau_u_lk: '/itau_coe_new_projs(748e7ad7-3ba2-ed11-aad1-002248370384)',
      templateCreateSession: 'rc6_sessao_atendimento',
      templateAusente: 'rc6_nice_ausente',
      retrieveRecordTable: 'iresolve_itau_interacao',
      retrieveRecordCol: 'iresolve_atnd_grntid',
      fieldnegocio: 'iresolve_st_plugin',
    },

    VEICULOS: {
      itau_name: 'Atender Veículos',
      itau_u_nomeprojeto: 'Squad Atendimento Veículos',
      itau_u_lk: '/itau_coe_new_projs(fbf27a0a-5dad-ed11-83ff-0022483606e7)',
      templateCreateSession: 'xv2_atend_veic_ticket',
      templateAusente: 'xv2_atend_notifica_ausente',
      retrieveRecordTable: 'xv2_itau_interacao_xv2_atendimento_veiculos',
      retrieveRecordCol: 'xv2_atendimento_veiculosid',
      fieldnegocio: 'xv2_st_plugin',
    },

    GERENTES_VEICULOS: {
      itau_name: 'Atender Veículos',
      itau_u_nomeprojeto: 'Squad Atendimento Veículos',
      itau_u_lk: '/itau_coe_new_projs(748e7ad7-3ba2-ed11-aad1-002248370384)',
      templateCreateSession: 'xv2_atend_veic_ticket',
      templateAusente: 'xv2_atend_notifica_ausente',
      retrieveRecordTable: 'xv2_itau_interacao_xv2_atendimento_veiculos',
      retrieveRecordCol: 'xv2_atendimento_veiculosid',
      fieldnegocio: 'xv2_st_plugin',
    },

    CONSORCIO: {
      itau_name: 'Atender Consórcios',
      itau_u_nomeprojeto: 'Squad Atendimento Consórcio',
      itau_u_lk: '/itau_coe_new_projs(58a0918a-61da-ee11-904c-002248d2cd94)',
      templateCreateSession: 'pa6_atendi_consorcio_barra',
      templateAusente: 'pa6_atend_notifica_ausente',
      retrieveRecordTable: 'pa6_itau_interacao_pa6_atendimento_consorcio',
      retrieveRecordCol: 'pa6_atendimento_consorcioid',
      fieldnegocio: 'pa6_st_plugin',
    },

    IMOBILIARIO: {
      itau_name: 'Modernização do Crédito Imobiliário',
      itau_u_nomeprojeto: 'Modernização do Crédito Imobiliário',
      itau_u_lk: '/itau_coe_new_projs(83624aca-6be3-ed11-8848-0022483606e7)',
      templateCreateSession: 'oy8_ticket_imob',
      templateAusente: 'oy8_atend_notifica_ausente',
      retrieveRecordTable: 'itau_incident_InteracaoId_itau_interacao',
      retrieveRecordCol: 'incidentid',
      fieldnegocio: 'oy8_st_plugin',
    },

    CONSIGNADO: {
      itau_name: 'Consignado',
      itau_u_nomeprojeto: 'Squad Consignado',
      itau_u_lk: '/itau_coe_new_projs(1dc21fd0-eda6-ed11-aad0-00224835d91f)',
      templateCreateSession: 'xc7_consignado_ticket',
      templateAusente: 'xc7_atend_notifica_ausente',
      retrieveRecordTable: 'xc7_itau_interacao_atendimento_consignado',
      retrieveRecordCol: 'xc7_atendimento_consignadoid',
      fieldnegocio: 'xc7_st_plugin',
    },

    SEGUROS: {
      itau_name: 'Atender Seguros',
      itau_u_nomeprojeto: 'Atender Seguros',
      itau_u_lk: '/itau_coe_new_projs(1105788f-3aa2-ed11-aad1-002248e0b395)',
      templateCreateSession: 'xs3_atender_seguros_operacao',
      templateAusente: 'xs3_nice_ausente',
      retrieveRecordTable: 'itau_incident_InteracaoId_itau_interacao',
      retrieveRecordCol: 'incidentid',
      fieldnegocio: 'xs3_st_plugin',
    },

    DEFAULT: {
      itau_name: 'Atender Seguros',
      itau_u_nomeprojeto: 'Atender Seguros',
      itau_u_lk: '/itau_coe_new_projs(1105788f-3aa2-ed11-aad1-002248e0b395)',
      templateCreateSession: 'xs3_atender_seguros_operacao',
      templateAusente: 'xs3_nice_ausente',
      retrieveRecordTable: 'itau_incident_InteracaoId_itau_interacao',
      retrieveRecordCol: 'incidentid',
      fieldnegocio: 'xs3_st_plugin',
    },
  };

export const IIbbaProvidersConfig: Record<string, IChannelProviderVariables> = {
  IBBA: {
    itau_name: 'IBBA - Atendimento Cash',
    itau_u_nomeprojeto: 'IBBA - Atendimento Cash',
    itau_u_lk: '/itau_coe_new_projs(e33ef4af-c41c-ee11-8f6d-002248e0b395)',
    templateCreateSession: 'jw7_ibba_guia_nice',
    templateAusente: '',
    retrieveRecordTable: 'itau_incident_InteracaoId_itau_interacao',
    retrieveRecordCol: 'incidentid',
    fieldnegocio: 'itau_name',
  },
};

export const IRecuperacaoProviderConfig: Record<string, IChannelProviderVariables> = {
  RECUPERACAO: {
      itau_name: 'Recuperacao PF',
      itau_u_nomeprojeto: 'Recuperacao PF',
      itau_u_lk: '/itau_coe_new_projs(8afd4f5e-43b8-f111-aaab-000d3ac162a9)',
      templateCreateSession: 'yn4_session_Ticket',
      retrieveRecordTable: 'itau_incident_InteracaoId_itau_interacao',
      retrieveRecordCol: 'incidentid',
      fieldnegocio: 'yn4_st_plugin',
    },
};

export const IGerentesPfProvidersConfig: Record<
  string,
  IChannelProviderVariables
> = {
  GERENTESPF: {
    itau_name: 'Projeto Itaú Resolve',
    itau_u_nomeprojeto: 'Projeto Itaú Resolve',
    itau_u_lk: '/itau_coe_new_projs(748e7ad7-3ba2-ed11-aad1-002248370384)',
    templateCreateSession: 'rc6_sessao_atendimento_cc',
    templateAusente: 'rc6_nice_ausente',
    retrieveRecordTable: 'iresolve_itau_interacao',
    retrieveRecordCol: 'iresolve_atnd_grntid',
    fieldnegocio: 'iresolve_st_plugin',
  },
  JURIDICO: {
    itau_name: 'Projeto Itaú Resolve',
    itau_u_nomeprojeto: 'Projeto Itaú Resolve',
    itau_u_lk: '/itau_coe_new_projs(748e7ad7-3ba2-ed11-aad1-002248370384)',
    templateCreateSession: 'rc6_sessao_atendimento',
    templateAusente: 'rc6_sessao_atendimento_cc',
    retrieveRecordTable: 'iresolve_itau_interacao',
    retrieveRecordCol: 'iresolve_atnd_grntid',
    fieldnegocio: 'iresolve_st_plugin',
  },
  AGRO: {
    itau_name: 'Projeto Itaú Resolve',
    itau_u_nomeprojeto: 'Projeto Itaú Resolve',
    itau_u_lk: '/itau_coe_new_projs(748e7ad7-3ba2-ed11-aad1-002248370384)',
    templateCreateSession: 'rc6_sessao_atendimento',
    templateAusente: 'rc6_sessao_atendimento_cc',
    retrieveRecordTable: 'iresolve_itau_interacao',
    retrieveRecordCol: 'iresolve_atnd_grntid',
    fieldnegocio: 'iresolve_st_plugin',
  },
  INVEST: {
    itau_name: 'Projeto Itaú Resolve',
    itau_u_nomeprojeto: 'Projeto Itaú Resolve',
    itau_u_lk: '/itau_coe_new_projs(748e7ad7-3ba2-ed11-aad1-002248370384)',
    templateCreateSession: 'rc6_sessao_atendimento',
    templateAusente: 'rc6_sessao_atendimento_cc',
    retrieveRecordTable: 'iresolve_itau_interacao',
    retrieveRecordCol: 'iresolve_atnd_grntid',
    fieldnegocio: 'iresolve_st_plugin',
  },
};
